exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-tools[data-v-7258874a]{\n  text-align: right;\n}\n.modify_box[data-v-7258874a]{\n  width: 52px;\n  margin-bottom: 10px;\n}\n.maintenance_description[data-v-7258874a]{\n  max-width: 350px;\n  padding: 0;\n  margin-bottom: 0;\n  font-family: inherit;\n  font-size: inherit;\n}\n", ""]);

// exports
